"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
exports.__esModule = true;
__exportStar(require("./article"), exports);
__exportStar(require("./cold-article"), exports);
__exportStar(require("./home"), exports);
__exportStar(require("./hot-article"), exports);
__exportStar(require("./newsroom"), exports);
__exportStar(require("./page-type"), exports);
__exportStar(require("./page"), exports);
//# sourceMappingURL=index.js.map